import React from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Styles } from '@t2c/shared-fe';
import { NextImage } from '@sdf/base';
import Image from 'next/image';

interface CreationBtnCardProps {
  title: string;
  subText: string;
  buttonText: string;
  onButtonClick: () => void;
  isButtonDisabled: boolean;
  icon: string;
}

export const CreationBtnCard: React.FC<CreationBtnCardProps> = ({
  title,
  subText,
  buttonText,
  onButtonClick,
  isButtonDisabled,
  icon,
}) => {
  return (
    <Card sx={styles.card}>
      {title === 'Timeline Editor' && (
        <Typography position={'absolute'} sx={styles.newChip}>
          New
        </Typography>
      )}

      <Stack sx={styles.container}>
        <Stack flexDirection={'row'} alignItems={'center'} height={'100%'} mt={8}>
          <NextImage src={'/assets/MessageImg.svg'} alt="" width={94} height={43} />
          <NextImage src={'/assets/TreeImg.svg'} alt="" width={123} height={125} />
        </Stack>
        <Stack flexDirection={'row'} alignItems={'center'} gap={5}>
          <Stack>
            <Typography sx={styles.title}>{title}</Typography>
            <Typography sx={styles.subText}>{subText}</Typography>
          </Stack>

          <NextImage src={`/assets/icons/${icon}`} alt="" width={141} height={88} />
        </Stack>
        <Button
          sx={styles.createBtn}
          variant="contained"
          onClick={onButtonClick}
          disabled={isButtonDisabled}
        >
          {buttonText}
        </Button>
      </Stack>
      <Image
        src={'/assets/Ellipse.svg'}
        alt={``}
        fill
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          zIndex: -1,
          position: 'absolute',
          left: '42%',
        }}
      />
    </Card>
  );
};

const styles: Styles = {
  card: {
    borderRadius: '16px',
    padding: '0px 26px',
    background: (theme) => theme.palette.gradients.gradient7,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight: '167px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    transition: 'all 0.3s ease',
    position: 'relative',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  container: {
    px: 4,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    columnGap: 3,
    rowGap: 3,
    '@media (max-width: 1000px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  title: {
    color: (theme) => theme.palette.background.activeBorder,
    fontWeight: '500',
    fontSize: 32,
  },
  subText: {
    color: (theme) => theme.palette.text.primary,
    fontWeight: '400',
    fontSize: 14,
    marginTop: 0.5,
  },
  createBtn: {
    color: (theme) => theme.palette.text.primary,
    boxShadow: 'none',
    width: 322,
    height: 58,
    fontWeight: 500,
    fontSize: '18px',
    '&:hover': {
      // transform: 'scale(1.02)',
      // background: (theme) => theme.palette.gradients.cardGradient2,
      // borderImage: (theme) => theme.palette.gradients.cardBorderGradient2,
      borderImageSlice: 1,
    },
  },
  newChip: {
    left: 15,
    top: 15,
    py: '6px',
    backgroundColor: (theme) => theme.palette.background.activeBorder,
    borderRadius: '80px',
    boxShadow: '4px 4px 0.9px #000000B0',
    fontSize: '14px',
    width: '82px',
    textAlign: 'center',
  },
  arrowContainer: {
    position: 'absolute',
    bottom: '10px',
    left: '5%',
    transition: 'left 0.5s',
    opacity: 0,
    '.MuiCard-root:hover &': {
      left: '85%',
      opacity: 1,
    },
  },
};
